import Api from '../../api/index';
// import idb from '../../idb/Proposals'
import { networkInterfaces } from 'os';

const Proposal = {
	namespaced: true,
  state: {
    allProposals: null,
    oneProposal: null,

    createProposalWasGood: null,
    createProposalMessage: null,

    updateProposalWasGood: null,
    updateProposalMessage: null,
  },

  mutations: {

    createResponse(state, {was_good, msg}){
      state.createProposalWasGood = was_good
      state.createProposalMessage = msg
      setTimeout(() => {
        state.createProposalWasGood = null
      }, 100);
    },
    updateResponse(state, {was_good, msg}){
      state.updateProposalWasGood = was_good
      state.updateProposalMessage = msg
      setTimeout(() => {
        state.updateProposalWasGood = null
      }, 100);
    },
  },
  actions: {
    // index(context, filter){
    //   if (!filter){
    //     context.commit('resetAllProposals')
    //   }
    //   Api.Proposal.index(filter)
    //     .then(response => response.data)
    //     .then(allProposals => {             
    //       context.commit('setAllProposals', {all: allProposals, filter: filter})   
    //     }).catch(function(error) {
    //          // auto-comment// console.log(error);
    //       context.commit('setOfflineProposals')
    //     });
    // },
    // show(context, id){
    //   Api.Proposal.show(id)
    //     .then(response => response.data)
    //     .then(oneProposal => {
    //       context.commit('setOneProposal', oneProposal)
    //     }).catch(function(error){
    //          // auto-comment// console.log(error)
    //     });
    // },

    create(context, new_Proposal) {
      Api.Proposal.create(new_Proposal)
        .then(r=>r.data)
        .then(Proposal=>{
          context.commit('createResponse', {msg: '', was_good: true});
          // this.allProposals = Proposals.data.map(o=>o.attributes)
        }).catch(err=>{
             // auto-comment// console.log({err});
          context.commit('createResponse', {msg: '', was_good: false});
        })
    },
    update(context, new_Proposal) {
      Api.Proposal.update(new_Proposal)
        .then(r=>r.data)
        .then(Proposal=>{
          context.commit('updateResponse', {msg: '', was_good: true});
          // this.allProposals = Proposals.data.map(o=>o.attributes)
        }).catch(err=>{
             // auto-comment// console.log({err});
          context.commit('updateResponse', {msg: '', was_good: false});
        })
    },

  }
}

export default Proposal;